export enum UserRole {
    Guest = 'Guest',
    User = 'User',
    Admin = 'Admin'
}
